module.exports = __webpack_public_path__ + "img/ga.c921b411.svg";